export default function SortAscendingIcon({ size = 20, ...props }) {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.75"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
            focusable="false"
            {...props}
        >
            <path d="M7 20V5" />
            <path d="m3.5 8.5 3.5-3.5 3.5 3.5" />
            <path d="M14 6h3" />
            <path d="M14 11h5" />
            <path d="M14 16h7" />
        </svg>
    );
}
